export const mutations = {
  addAvis(state, avis) {
    state.avis = avis;
  },
  setAvis(state, avis) {
    state.avis = avis;
  },
  addAviss(state, avis) {
    state.aviss = [...avis];
  },
  addAvissPage(state, avis) {
    state.aviss = [...avis.content];
    console.log(avis.content);
    state.pagination = {
      pageable: avis.pageable,
      totalElements: avis.totalElements,
      totalPages: avis.totalPages,
    };
  },
};
